<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="80%"
        :show-close="false"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        @opened="onDataChange"
      >
      <div slot="title" class="header-title">
        <div class="dgTitle">{{ damnm }}断面图</div>
        <el-image class="dgImg2" :src="require('../../../assets/icons/dg-gb.png')" @click="handleOpen(false)"></el-image>
      </div>
      <div ref="sectionView" id="sectionView" class="sectionStyle"></div>
      <span slot="footer" class="dialog-footer">
       <el-button @click="handleOpen(false)" class="dgClose">关 闭</el-button>
    </span>
    </el-dialog>
</template>
<script>
import * as THREE from "../../../utils/basejs/three.min";
import {addConstShape, addFont, clearScene} from "../../../utils/basejs/addThreeThings";
import {OrbitControls} from "../../../utils/basejs/OrbitControls";

let renderer = null;
let scene = null;
let camera = null;
let controls = null;

export default {
  name: "sectionViewOpen",
  data() {
    return {
      damnm: '',
      loading: false,
      dialogVisible: false,
      timeDiv: null,
      requestID: null,
      damcd: null
    };
  },
  methods: {
    destroy(){
      if (scene) {
        try {
          clearScene(scene);
          controls.dispose();
          scene.remove();
          scene.clear();
          scene = null;
          renderer.renderLists.dispose();
          renderer.dispose();
          renderer.forceContextLoss();
          renderer.domElement = null;
          renderer.content = null;
          camera = null;
          renderer = null;
          cancelAnimationFrame(this.requestID);
          THREE.Cache.clear();
        }catch (e){
          //console.log(e);
        }
      }
    },
    handleOpen(open){
      this.dialogVisible = open;
      if(!open){
        clearScene(scene)
      }
    },
    onSectionViewOpen(damcd) {
      this.damcd = damcd;
      this.handleOpen(true);
    },
    onDataChange(){
      this.loading = true;
      if(!this.requestID) {
        this.threeInit();
      }
      this.getDam(this.damcd);
    },
    getDam(damcd){
      const params = {damcd: damcd,rescd: null};
      this.request.post('/rm-bsection/v1/getSectionMap',params).then(res =>{
        if(res.ok){
          clearScene(scene);
          const data = res.data;
          const target = data.target;
          this.damnm = data.damnm;
          if(target){
            const x = parseFloat(target.x);
            const y = parseFloat(target.y);
            const z = parseFloat(target.z) ;
            camera.position.set(x,y,z);
            controls.target.set(x,y,0);
          }
          const back = data.backfillCoords;
          const fontSize = parseFloat(data.size);
          const width = parseFloat(data.width);
          this.addThings(data.coreCoords,data.damCoords,data.rmBSempVOS,back,fontSize,width);
        }else {
          this.$message.error(res.error.message);
          this.loading = false;
        }
      });
    },
    addThings(coreCoords,damCoords,semps,back,fontSize,damWidth){
          const shapes = [];
          if(coreCoords){
              const material = new THREE.MeshBasicMaterial({	color: 0xa9a9a9,side: THREE.DoubleSide});
              // #708090
              const coreShape = new THREE.Shape();
              let isFirst = true;
              let lastX = null;
              let lastY = null;

              for(let coords of coreCoords){
                if(isFirst){
                  lastX = parseFloat(coords.x);
                  lastY = parseFloat(coords.y);
                  coreShape.moveTo(lastX,lastY)
                  isFirst = false;
                }else{
                  coreShape.lineTo(parseFloat(coords.x),parseFloat(coords.y));
                }

              }
              coreShape.lineTo(lastX,lastY);
              const position = {x:0,y:0,z:0.1};
              shapes.push({ shape: coreShape, position: position, material : material,name:'core'});//
          }

          if(damCoords){
              const material = new THREE.MeshBasicMaterial({	color: 0x8b4513,side: THREE.DoubleSide});
              const damShape = new THREE.Shape();
              let isFirst = true;
              let lastX = null;
              let lastY = null;
              for(let coords of damCoords){
                if(isFirst){
                  lastX = parseFloat(coords.x);
                  lastY = parseFloat(coords.y);
                  damShape.moveTo(lastX,lastY)
                  isFirst = false;
                }else{
                  damShape.lineTo(parseFloat(coords.x),parseFloat(coords.y));
                }

              }
              damShape.lineTo(lastX,lastY);
              const position = {x:0,y:0,z:0};
              shapes.push({ shape: damShape, position: position, material : material,name:'dam'});//
          }
          if(back){
            // const material = new THREE.MeshBasicMaterial({	color: 0x4EABFE,side: THREE.DoubleSide});
            const material = new THREE.MeshBasicMaterial({	color: 0xCD853F,side: THREE.DoubleSide});
            const backShape = new THREE.Shape();
            let isFirst = true;
            for(let coords of back){
              if(isFirst){
                backShape.moveTo(parseFloat(coords.x),parseFloat(coords.y))
                isFirst = false;
              }else{
                backShape.lineTo(parseFloat(coords.x),parseFloat(coords.y));
              }

            }
            const position = {x:0,y:0,z:0};
            shapes.push({ shape: backShape, position: position, material : material,name:'back'});//
          }
          addConstShape(shapes,scene);
      if(semps){
        const sempsShape = [];
        const textArray = [];
        // const material = new THREE.MeshBasicMaterial({	color: 0x4EABFE,side: THREE.DoubleSide});
        const material2 = new THREE.MeshBasicMaterial({	color: 0x6D6D6D});
        const material1 = new THREE.MeshBasicMaterial({	color: 0xEEE9E9,side: THREE.DoubleSide});
        const position = {x:0,y:0,z:0.2};
        for(let s of semps){
          const sempShape = new THREE.Shape().moveTo(0,0);
          const x = parseFloat(s.tbbtX);
          const minX = x - damWidth;
          const maxX = x + damWidth;
          const maxY = parseFloat(s.tbbtY);
          const minY = parseFloat(s.tbtpY);
          sempShape.lineTo(minX,minY).lineTo(minX,maxY).lineTo(maxX,maxY).lineTo(maxX,minY).lineTo(minX,minY);

          textArray.push({text:s.mpcd,material : material2,position:{x:x,y: maxY + 1,z:0.4},size:fontSize});
          sempsShape.push({ shape: sempShape, position: position, material : material1,name: s.mpcd});

        }
        addFont(textArray,material2,scene);
        addConstShape(sempsShape,scene);
      }
          this.loading = false;
    },
    cameraRange(){
      if(camera.position.x < 400){
        if(camera.position.y < 425) {
          controls.target.set(400, 425, controls.target.z);
          camera.position.set(400, 425, camera.position.z);
        }else if(camera.position.y > 690){
          controls.target.set(400, 690, controls.target.z);
          camera.position.set(400, 690, camera.position.z);
        }else{
          controls.target.set(400,controls.target.y,controls.target.z);
          camera.position.set(400,camera.position.y,camera.position.z);
        }
      }else
      if(camera.position.x > 1600){
        if(camera.position.y < 425) {
          controls.target.set(1600, 425, controls.target.z);
          camera.position.set(1600, 425, camera.position.z);
        }else if(camera.position.y > 690){
          controls.target.set(1600, 690, controls.target.z);
          camera.position.set(1600, 690, camera.position.z);
        }else{
          controls.target.set(1600,controls.target.y,controls.target.z);
          camera.position.set(1600,camera.position.y,camera.position.z);
        }
      }else{
        if(camera.position.y < 425) {
          controls.target.set(controls.target.x, 425, controls.target.z);
          camera.position.set(camera.position.x, 425, camera.position.z);
        }else if(camera.position.y > 690){
          controls.target.set(controls.target.x,690, controls.target.z);
          camera.position.set(camera.position.x, 690, camera.position.z);
        }else{
          controls.saveState();
        }
      }
    },
    animate() {
      this.requestID = requestAnimationFrame(this.animate);
      controls.update();
      // this.cameraRange();
      renderer.render(scene, camera);
    },
    threeInit() {
      if(this.$refs.sectionView) {
        this.timeDiv = this.$refs.sectionView;
      }
      camera = new THREE.PerspectiveCamera(
          80,
          this.timeDiv.offsetWidth / this.timeDiv.offsetHeight,
          1,
          12000
      );
      // camera.position.set(0, 30, 0);
      camera.position.set(950,500,1000);
      renderer = new THREE.WebGLRenderer({antialias: true});
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(
          this.timeDiv.offsetWidth,
          this.timeDiv.offsetHeight
      );
      renderer.antialias=true;
      renderer.alpha=true;
      this.timeDiv.append(renderer.domElement);
      scene = new THREE.Scene();
      scene.background = new THREE.Color('#FFF');
      controls = new OrbitControls(
          camera,
          renderer.domElement
      );
      controls.enableRotate = true;
      controls.autoRotate = false;
      controls.minDistance = 20;
      controls.maxDistance = 1000;
      // controls.target0.set(800, 400, 0);
      controls.target.set(950, 500, 0);

      controls.mouseButtons = {
        LEFT: THREE.MOUSE.PAN,
        MIDDLE: THREE.MOUSE.DOLLY,
        RIGHT: THREE.MOUSE.ROTATE,
      };
      this.animate();
    },
  }
};
</script>
<style scoped>
.sectionStyle{
  width: 100%;
  height: 100%;
}
::v-deep .el-dialog {
  margin: 0 auto;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  height: 6vh;
  line-height: 6vh;
  padding: 0;
  background-color: #f9f9ff;
  position: relative;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

::v-deep .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 10px;
  height: 5vh;
  line-height: 5vh;
}

::v-deep .el-dialog__body {
  padding: 10px 20px 0px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  position: absolute;
  left: 0;
  top: 5vh;
  bottom: 70px;
  right: 0;
  overflow: auto;
}

::v-deep .dialog-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 70px;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  align-items: Center;
  box-sizing: border-box;
  padding-right: 20px;
}

::v-deep .el-dialog {
  height: 70%;
}
.dgImg2{
  position: absolute;
  right: 2vh;
  top:1.5vh;
  width: 3vh;
  height: 3vh;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.dgClose{
  width: 8vh;
  height: 3vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #0066ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: solid 1px #53abfd;
  border-radius: 2px;
}
.dgTitle{
  margin-left: 2vh;
  font-family: PingFang SC;
  font-size: 1.6vh;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vh;
  color: #323232;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
}
</style>
